import React, { useContext } from "react";
import Link from "next/link";
import Image from "next/image";
import dynamic from "next/dynamic";
import {
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
  TwitterIcon,
  WhatsappIcon,
  FacebookMessengerIcon,
} from "react-share";
import { FaYoutube } from "react-icons/fa";

//internal import
import { UserContext } from "@context/UserContext";
import MobileFooterMenu from "./MobileFooterMenu";

const Footer = () => {
  const {
    state: { userInfo },
  } = useContext(UserContext);

  return <>
    <div className="block md:hidden pb-16 lg:pb-0 xl:pb-0 bg-white">
      <div className=" pb-16 lg:pb-0 xl:pb-0 bg-white">
        <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
          <MobileFooterMenu userInfo={userInfo} />
        </div>
      </div>
    </div>
    <div className="hidden md:block">
      <div className=" pb-16 lg:pb-0 xl:pb-0 bg-white">
        <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
          <div className="grid grid-cols-2 md:grid-cols-7 xl:grid-cols-12 gap-5 sm:gap-9 lg:gap-11 xl:gap-7 py-10 lg:py-16 justify-between">
            <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3">
              <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                Information
              </h3>
              <ul className="text-sm flex flex-col space-y-3">
                <li className="flex items-baseline">
                  <Link
                    href="/about-us"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      About Us
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href="/contact-us"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Contact us
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href="https://forum.cubenationshop.com/"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Community Forum
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href="https://blog.cubenationshop.com/"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Latest news
                    
                  </Link>
                </li>
              </ul>
            </div>
            <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3">
              <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                CN Recommends
              </h3>
              <ul className="text-sm lg:text-15px flex flex-col space-y-3">
                <li className="flex items-baseline">
                  <Link
                    href="/relatedProduct/starter"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Starter
                    
                  </Link>
                </li>

                <li className="flex items-baseline">
                  <Link
                    href="/relatedProduct/everyone"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Everyone
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href="/relatedProduct/pro"
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Professional
                    
                  </Link>
                </li>                  
              </ul>
            </div>
            <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3">
              <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                My Account
              </h3>
              <ul className="text-sm lg:text-15px flex flex-col space-y-3">
                <li className="flex items-baseline">
                  <Link
                    href={`${userInfo?.email ? "/user/dashboard" : "#"}`}
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Dashboard
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href={`${userInfo?.email ? "/user/my-orders" : "#"}`}
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      My Orders
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href={`${userInfo?.email ? "/user/dashboard" : "#"}`}
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Recent Orders
                    
                  </Link>
                </li>
                <li className="flex items-baseline">
                  <Link
                    href={`${userInfo?.email ? "/user/update-profile" : "#"}`}
                    className="text-gray-600 inline-block w-full hover:text-emerald-500">
                    
                      Updated Profile
                    
                  </Link>
                </li>
              </ul>
            </div>
            <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3">
              <Link href="/" className="mr-3 lg:mr-12 xl:mr-12" rel="noreferrer">

                <Image
                  width={130}
                  height={25}
                  src="/logo/cb-logo-black.png"
                  alt="logo"
                  placeholder="blur"
                  blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                  style={{
                    maxWidth: "100%",
                    height: "auto"
                  }} />

              </Link>
              <p className="leading-7 font-sans text-sm text-gray-600 mt-3">
                <span>
                  ⛟ Warehouse: C-91/93, W2, Eastern Housing, Pallabi, Eastern Housing,{" "}
                  Dhaka-1216
                </span>
                <br />
                <a href="tel:+8809613750849"><span>✆ 09613750849</span></a> <br />
                <span>TIN:479459364864</span>
              </p>
            </div>
          </div>

          <hr className="hr-line"></hr>

          <div className="mx-auto max-w-screen-2xl px-4 sm:px-10 bg-gray-50 shadow-sm border border-gray-50 rounded-lg">
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-5 sm:gap-9 lg:gap-11 xl:gap-7 py-8 items-center justify-between">
              <div className="col-span-1">
                <span className="text-base leading-7 font-medium block mb-2 pb-0.5 hidden">
                  Follow Us
                </span>
                <ul className="text-sm flex">
                  <li className="flex items-center mr-3 transition ease-in-out duration-500">
                    <Link
                      href="https://www.facebook.com/CubeNationBD/"
                      aria-label="Social Link"
                      rel="noreferrer"
                      target="_blank"
                      className="block text-center mx-auto text-blue-500 hover:text-white">

                      <FacebookIcon size={34} round="true" />

                    </Link>
                  </li>
                  <li className="flex items-center  mr-3 transition ease-in-out duration-500">
                    <Link
                      href="https://www.youtube.com/c/CubeNationBD"
                      aria-label="Social Link"
                      rel="noreferrer"
                      target="_blank"
                      className="block text-center mx-auto text-red-600 hover:text-red-600">

                      <FaYoutube size={34} round="true" />

                    </Link>
                  </li>
                  <li className="flex items-center mr-3 transition ease-in-out duration-500">
                    <Link
                      href="https:/m.me/cubenationbd"
                      aria-label="Social Link"
                      rel="noreferrer"
                      target="_blank"
                      className="block text-center mx-auto text-gray-500 hover:text-white">

                      <FacebookMessengerIcon size={34} round="true" />

                    </Link>
                  </li>
                  <li className="flex items-center  mr-3 transition ease-in-out duration-500">
                    <Link
                      href="https://bd.linkedin.com/company/cubenation"
                      aria-label="Social Link"
                      rel="noreferrer"
                      target="_blank"
                      className="block text-center mx-auto text-gray-500 hover:text-white">

                      <LinkedinIcon size={34} round="true" />

                    </Link>
                  </li>
                  <li className="flex items-center  mr-3 transition ease-in-out duration-500">
                    <Link
                      href="https://wa.me/8801972810849"
                      aria-label="Social Link"
                      rel="noreferrer"
                      target="_blank"
                      className="block text-center mx-auto text-gray-500 hover:text-white">

                      <WhatsappIcon size={34} round="true" />

                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-span-1 text-center hidden lg:block md:block">
                <p className="text-base leading-7 font-medium block">
                  Call Us Today!
                </p>
                <h5 className="text-2xl font-bold text-emerald-500 leading-7">
                <div>{" "}
            <a
              href="tel:+8801972810849"                
            >
              +88 01972810849
            </a>
               </div>               
                </h5>
              </div>
              <div className="col-span-1 hidden lg:block md:block">
                <ul className="lg:text-right">
                  <li className="px-1 mb-2 md:mb-0 transition hover:opacity-80 inline-flex">
                    <Image
                      width={274}
                      height={85}
                      className="w-3/5"
                      src="/logo/logo-dark.svg"
                      alt="CN Logo"
                      placeholder="blur"
                      blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      style={{
                        maxWidth: "100%",
                        height: "auto"
                      }} />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto max-w-screen-2xl px-3 sm:px-10 flex justify-center py-4">
          <p className="text-sm text-gray-500 leading-6">
            Copyright 2025 <b>CubeNation Bangladesh</b>. Powered by {" "}
            <Link
              href="https://brainstation-23.com/?bc"
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-500">
              
                Brain Station 23
              
            </Link>
            , All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </>;
};

export default dynamic(() => Promise.resolve(Footer), { ssr: false });